import React from 'react';
import { IoMdArrowDropdown } from 'react-icons/io';
import { FaSortAmountUpAlt, FaSortAmountDownAlt, FaEyeSlash } from 'react-icons/fa';
import { NavDropdown } from 'react-bootstrap';
import './dropdown.css';

/**
 * TimeDropdownComponent (Date/Time Field Dropdown)
 * 
 * Dropdown menu for date/time datatable columns providing temporal sort options:
 * - Sort older to newer (ascending)
 * - Sort newer to older (descending)
 * - Hide column from view
 * Calls onClick callback with selected option text.
 * 
 * @param {Object} props - Component props
 * @param {Function} props.onClick - Callback receiving selected option text
 * @param {string} props.sortAsc - Sort ascending value
 * @param {string} props.sortDesc - Sort descending value
 * @param {string} props.hideField - Hide field value
 * @returns {JSX.Element} Column header dropdown for date fields
 */

const TimeDropdownComponent = (props) => {

    function selectedDropdown(event) {
        props.onClick(event.target.innerText);
    }

    return (
        <>
            <NavDropdown align="end" className="sort-navbardropdown" title={<IoMdArrowDropdown className="sort-navbaricon" />} id="basic-nav-dropdown">
                <NavDropdown.Item onClick={selectedDropdown} value={props.sortAsc} className="sort-navbardropdownitem" id="sort-navbaractive"><FaSortAmountDownAlt /> Sort older to newer</NavDropdown.Item>
                <NavDropdown.Item onClick={selectedDropdown} value={props.sortDesc} className="sort-navbardropdownitem" id="sort-navbaractive"><FaSortAmountUpAlt /> Sort newer to older</NavDropdown.Item>
                <NavDropdown.Item onClick={selectedDropdown} value={props.hideField} className="sort-navbardropdownitem" id="sort-navbaractive"><FaEyeSlash /> Hide Field</NavDropdown.Item>
            </NavDropdown>
        </>
    );
}

export default TimeDropdownComponent;